export const initialState = {
    comming_soon: false,
    logo: '',
    login: false,
};
